var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgWifi = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("g", {
    clipPath: "url(#clip0_2667_5676)"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.90307C8.53071 5.90307 5.1806 7.16951 2.57805 9.46484C2.1845 9.81193 1.58424 9.7741 1.23733 9.38033C0.890426 8.98656 0.928241 8.38597 1.32179 8.03887C4.27134 5.43749 8.06814 4.0022 12 4.0022C15.9319 4.0022 19.7287 5.43749 22.6782 8.03887C23.0718 8.38597 23.1096 8.98656 22.7627 9.38033C22.4158 9.7741 21.8155 9.81193 21.4219 9.46484C18.8194 7.16951 15.4693 5.90307 12 5.90307Z",
    fill: props.color || 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.038 10.6548C9.81658 10.6548 7.66542 11.4337 5.95855 12.8562C5.55544 13.1922 4.95647 13.1375 4.62071 12.7342C4.28495 12.3309 4.33955 11.7316 4.74266 11.3956C6.79091 9.68866 9.3723 8.75391 12.038 8.75391C14.7037 8.75391 17.2851 9.68866 19.3333 11.3956C19.7364 11.7316 19.791 12.3309 19.4553 12.7342C19.1195 13.1375 18.5205 13.1922 18.1174 12.8562C16.4106 11.4337 14.2594 10.6548 12.038 10.6548Z",
    fill: props.color || 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0047 15.4061C11.019 15.4061 10.0576 15.713 9.25396 16.2843C8.82628 16.5883 8.23327 16.4878 7.92943 16.0599C7.62558 15.632 7.72597 15.0387 8.15365 14.7347C9.27872 13.9349 10.6246 13.5052 12.0047 13.5052C13.3849 13.5052 14.7308 13.9349 15.8559 14.7347C16.2835 15.0387 16.3839 15.632 16.0801 16.0599C15.7762 16.4878 15.1832 16.5883 14.7555 16.2843C13.9519 15.713 12.9905 15.4061 12.0047 15.4061Z",
    fill: props.color || 'currentColor'
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0501 19.2067C11.0501 18.6817 11.4754 18.2562 12 18.2562H12.0095C12.5341 18.2562 12.9594 18.6817 12.9594 19.2067C12.9594 19.7316 12.5341 20.1571 12.0095 20.1571H12C11.4754 20.1571 11.0501 19.7316 11.0501 19.2067Z",
    fill: props.color || 'currentColor'
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "clip0_2667_5676"
  }, React.createElement("rect", {
    width: 22,
    height: 16.1549,
    fill: props.color || 'currentColor',
    transform: "translate(1 4.0022)"
  }))));
};
export default SvgWifi;